export default __webpack_public_path__ + "static/battery-friendly-m-bd96535b8d76762577cc1905903a1e1f.webp";